import { createSlice, nanoid } from '@reduxjs/toolkit'

const initialState = {
    items: {},
    order: [],
    activeChatId: null
}

export const normalizeChatArgs = (raw = {}) => {
  return {
    chatId: `C-${nanoid(6)}`,
    program: (raw.program ?? '').toString().toLowerCase(),
    receivedAt: Date.now(),
    args: { ...raw },
  }
}

export const dismissChatByCallId = (callId) => (dispatch, getState) => {
    if (!callId) return
    const { chatInbox } = getState()

    const chatId = chatInbox.order.find(id => {
        const item = chatInbox.items[id]
        const a = item?.args || item
        const cid = a?.callId ?? a?.callid
        return cid == callId
    })

    if (chatId) {
        dispatch(dismissChat(chatId))
    }
}


const chatInboxSlice = createSlice({
    name: 'chatInbox',
    initialState,
    reducers: {
        upsertChat(state, action) {
            const data = action.payload
            const id = data.chatId
            if (!id) return
            const incomingCallId = String(data.args?.callId ?? data.args?.callID ?? data.callId ?? data.callID ?? '')
            if (incomingCallId) {
                const dupKey = state.order.find(k => {
                    const a  = state.items[k]?.args || state.items[k]
                    const ex = a?.callId ?? a?.callID ?? a?.callid
                    return ex != null && String(ex) === incomingCallId
                })

                if (dupKey && dupKey !== id) {
                    return
                }
            }
            const prev = state.items[id]
            const wasInOrder = state.order.includes(id)

            const baseStatus = prev?.status ?? 'new'
            const hasCase = (prev?.caseId != null) || (data.caseId != null)
            const caseId = prev?.caseId ?? data.caseId ?? undefined

            let status
            if (!wasInOrder) {
                status = hasCase ? 'opened' : 'new'
            } else if (baseStatus === 'new' && hasCase) {
                status = 'opened'
            } else if (baseStatus === 'opened' && !hasCase) {
                status = 'new'
            } else {
                status = baseStatus
            }

            state.items[id] = {
                ...prev,
                ...data,
                status,
                caseId,
            }

            if (!wasInOrder) state.order.unshift(id)
        },

        dismissChat(state, action) {
            const id = action.payload
            if (!state.items[id]) return
            delete state.items[id]
            state.order = state.order.filter(x => x !== id)
            if (state.activeChatId === id) state.activeChatId = null
        },

        markOpened(state, action) {
            const { chatId, caseId } = action.payload || {}
            if (!state.items[chatId]) return
            state.items[chatId].status = 'opened'
            state.items[chatId].caseId = caseId
        },

        setChatDisplayNumberByCallId(state, action) {
            const { callId, name } = action.payload || {};
            if (!callId) return;

            const digits = String(name ?? '').replace(/\D/g, '');
            if (!digits) return;

            const chatId = state.order.find(id => {
                const item = state.items[id];
                const a = item?.args || item;
                const cid = a?.callId ?? a?.callid;
                return String(cid) === String(callId);
            });

            if (!chatId || !state.items[chatId]) return;

            if (state.items[chatId].displayNumber === digits) return;

            state.items[chatId].displayNumber = digits;
        },

    }
})

export const {
    upsertChat,
    dismissChat,
    markOpened,
    setChatDisplayNumberByCallId
} = chatInboxSlice.actions

export default chatInboxSlice.reducer
